import { labelRenderer } from './labels'

export const labelFormat = (key, array = [], fieldAsLabel = 'label') => {
   const object = array.find(item => item.key === key)
   return object ? labelRenderer(object[fieldAsLabel]) : key
}
